import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";

var CRMActions = require("lib/actions/CRMActions");
var CRMSelectors = require("lib/selectors/CRMSelectors");

var CurrentUser = require("lib/account/CurrentUser");

var Glyphicon = require("components/utility/icons/Glyphicon");
var LoadingButton = require("components/utility/LoadingButton");
var CRMTitleSelector = require("components/utility/inputs/CRMTitleSelector");
var AgentTaskForm = require("components/appdev/crm/AgentTaskForm");

import moment from "moment";

require("appdev/crm/new_deal_page.scss");

@connect(
	(state, props) => {
		var contactID = $wr.getURLParameterByName("contact_id");

		if (contactID) {
			var contact = CRMSelectors.contact({ state, id: $wr.getURLParameterByName("contact_id") });
		}

		var loading = !!(
			CRMSelectors.isLoadingContacts({ state, key: contactID }) ||
			CRMSelectors.isLoadingDeals({ state, key: "create" })
		)

		return {
			contact, loading,
			currentUserEmail: CurrentUser.get().email,
			dealSources: CurrentUser.get().crm_config.deal_sources,
			agentEmails: CurrentUser.get().crm_config.active_user_emails,
		}
	},
	(dispatch, props) => ({
		populateData: () => {
			var contactID = $wr.getURLParameterByName("contact_id");
			if (contactID) {
				return dispatch(CRMActions.fetchContact({
					id: contactID, embeds: [
						"contact.org", "contact.deal_source_options", "contact.user_options"
					]
				}))
			} else {
				return Promise.resolve();
			}
		},
		createDeal: (deal, tasks) => {
			return dispatch(CRMActions.createDeal({ deal, nextTasks: tasks }))
		}
	})
)
@providePopulateData({ waitForLoad: true })
class NewDealPage extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		this.state = {
			agentEmail: this.defaultAgentEmail(props),
			dealName: this.defaultDealName(props),
			orgLevel: this.defaultOrgLevel(props),
			dealSource: "",
			estimatedValue: "",

			contactTitle: "",
			contactFirst: "",
			contactLast: "",
			contactEmail: "",

			task: {
				active: true,
				date: moment().add(4, "days").format("YYYY-MM-DD"),
				text: "Incoming FU 1",
				agentEmail: this.defaultAgentEmail(props)
			},

			createdDealID: null,
		};
	}

	defaultAgentEmail(props) {
		props = props || this.props;
		if (props.contact) {
			if (_.includes(props.agentEmails, props.currentUserEmail)) {
				return props.currentUserEmail;
			}
		}
		return "";
	}
	defaultDealName(props, teacherName) {
		props = props || this.props;
		if (props.contact) {
			var org = this.org(props);
			var year = (new Date()).getFullYear();
			if (teacherName) {
				return org.name + " (" + org.address.state + ") - " + teacherName + " - " + year;
			} else {
				return org.name + " (" + org.address.state + ") - " + year;				
			}
		}
	}
	defaultOrgLevel(props) {
		props = props || this.props;
		if (props.contact) {
			var org = this.org(props);
			return org.custom_fields["Org Level"];
		}
	}	
	isOrgView(props) {
		props = props || this.props;
		return props.contact && props.contact.is_organization;
	}
	org(props) {
		props = props || this.props;
		if (props.contact) {
			return this.isOrgView(props) ? props.contact : props.contact.org;			
		}
	}

	useTeacherDealName(e) {
		$wr.nope(e);
		if (this.isOrgView()) {
			var teacherName = this.state.contactFirst + " " + this.state.contactLast;
		} else {
			var teacherName = this.props.contact.name;
		}
		var dealName = this.defaultDealName(this.props, teacherName);
		this.setState({ dealName });
	}

	canSave() {
		return !!(
			this.state.dealName   && this.state.dealName.trim().length &&
			this.state.orgLevel   && this.state.orgLevel.trim().length &&
			this.state.dealSource && this.state.dealSource.trim().length) && (
			this.state.agentEmail && this.state.agentEmail.trim().length) && (
				!this.isOrgView() || (
					this.state.contactFirst && this.state.contactFirst.trim().length &&
					this.state.contactLast  && this.state.contactLast.trim().length &&
					this.state.contactEmail && this.state.contactEmail.trim().length
				)
			);
	}

	onSave(goToQuotes) {
		var deal = {
			name: this.state.dealName,
			source: this.state.dealSource,
			owner_email: this.state.agentEmail,
			custom_fields: {
				"Org Level": this.state.orgLevel
			}
		}

		if (this.isOrgView()) {
			deal.contact = {
				title: this.state.contactTitle,
				first_name: this.state.contactFirst,
				last_name: this.state.contactLast,
				email: this.state.contactEmail,
				contact_id: this.org().id
			}
		} else {
			deal.contact_id = this.props.contact.id;
		}

		if (this.state.estimatedValue && this.state.estimatedValue.trim().length) {
			deal.value = parseFloat(this.state.estimatedValue.split(".")[0] + ".01");
		} else {
			deal.value = 0.0;
		}

		if (this.state.task && this.state.task.active) {
			var tasks = [{
				due_date: this.state.task.date,
				content: this.state.task.text,
				owner_email: this.state.task.agentEmail
			}]
		}

		this.props.createDeal(deal, tasks).then((response) => {
			var dealID = response.deals[0].id;
			if (goToQuotes) {
				$wr.redirect("/new_quotes?deal_id=" + dealID);
			} else {
				this.setState({ createdDealID: dealID });
			}
		});
	}

	updateTask(key, value) {
		var task = _.extend({}, this.state.task, { [key]: value });
		this.setState({ task })
	}

	renderDealSourceOptions() {
		return this.props.dealSources.slice().sort().map((source) => {
			return (
				<option key={ source } value={ source }>
					{ source }
				</option>
			);
		})
	}

	renderAgentOptions() {
		return this.props.agentEmails.slice().sort().map((email) => {
			return (
				<option key={ email } value={ email }>
					{ email }
				</option>
			);
		})
	}

	render() {
		var contact = this.props.contact;
		var org = this.org();

		if (!(contact && org)) {
			var orgName = "(No org, provide contact_id)";
		} else if (this.state.createdDealID) {
			var orgName = org.name;
			var content = (
				<p>
					Created! <a href={ DEAL_LINK_BASE + this.state.createdDealID } target="_blank">
						<Glyphicon icon="link" /> New deal
					</a>
				</p>
			);
		} else {
			var orgName = org.name;
			if (this.isOrgView()) {
				var contactContent = (
					<div className="row">
						<div className="col-sm-2">
							<label>
								Title
							</label>

							<CRMTitleSelector value={ this.state.contactTitle }
								onChange={ (e) => this.setState({ contactTitle: e.target.value }) } />
						</div>
						<div className="col-sm-3">
							<label>
								First Name
							</label>
							<input value={ this.state.contactFirst } className="form-control"
								onChange={ (e) => this.setState({ contactFirst: e.target.value }) } />
						</div>
						<div className="col-sm-3">
							<label>
								Last Name
							</label>
							<input value={ this.state.contactLast } className="form-control"
								onChange={ (e) => this.setState({ contactLast: e.target.value }) } />
						</div>
						<div className="col-sm-4">
							<label>
								Email
							</label>
							<input value={ this.state.contactEmail } className="form-control" type="email"
								onChange={ (e) => this.setState({ contactEmail: e.target.value }) } />
						</div>
					</div>
				)
			} else {
				var contactContent = (
					<div>
						Name: { contact.first_name } { contact.last_name }<br />
						Email: { contact.email }
					</div>
				)
			}

			var content = (
				<div>
					<h3>Primary Contact</h3>
					{ contactContent }

					<h3>Deal Info</h3>
					<div className="row">
						<div className="col-sm-6">
							<label>
								Name{" "}
								<a href="#" onClick={ this.useTeacherDealName } className="smallText">
									(use teacher format)
								</a>
							</label>
							<input value={ this.state.dealName } className="form-control"
								onChange={ (e) => this.setState({ dealName: e.target.value }) } />
						</div>
						<div className="col-sm-3">
							<label>
								Lead source
							</label>
							<select value={ this.state.dealSource } className="form-control"
								onChange={ (e) => this.setState({ dealSource: e.target.value }) }>
								<option value=""></option>
								{ this.renderDealSourceOptions() }
							</select>
						</div>
						<div className="col-sm-3">
							<label>
								Org Level
							</label>
							<select value={ this.state.orgLevel } className="form-control"
								onChange={ (e) => this.setState({ orgLevel: e.target.value }) }>
								<option value="Class">Class</option>
								<option value="School">School</option>
								<option value="District">District</option>
							</select>
						</div>
					</div>
					<div className="row">
						<div className="col-sm-3">
							<label>
								Estimated Value (optional)
							</label>
							<input value={ this.state.estimatedValue } className="form-control" type="number"
								onChange={ (e) => this.setState({ estimatedValue: e.target.value }) } />
						</div>
						<div className="col-sm-5">
							<label>
								Agent
							</label>
							<select value={ this.state.agentEmail } className="form-control"
								onChange={ (e) => this.setState({ agentEmail: e.target.value }) }>
								<option value=""></option>
								{ this.renderAgentOptions() }
							</select>
						</div>
					</div>
					<AgentTaskForm task={ this.state.task } onChange={ this.updateTask } />
					<div className="actions">
						<LoadingButton loading={ this.props.loading } text="Save"
							disabled={ !this.canSave() }
							className="btn buttonPrimary"
							onClick={ this.onSave.bind(this, false) } />
						<LoadingButton loading={ this.props.loading } text="Save & Quote"
							disabled={ !this.canSave() }
							className="btn buttonDefault"
							onClick={ this.onSave.bind(this, true) } />
					</div>
				</div>
			);
		}


		return (
			<div className="newDealPage container">
				<div className="headerSection">
					<header className="pageHeader">
						<h1>New Deal: { orgName }</h1>
					</header>
				
					{ content }
				</div>
			</div>
		);
	}

};

var DEAL_LINK_BASE = "https://app.futuresimple.com/sales/deals/";

NewDealPage.WrappedComponent.propTypes = PageStrictPropTypes({
	// Data from @connect
	contact: PropTypes.object,
	loading: PropTypes.bool,
	currentUserEmail: PropTypes.string,
	agentEmails: PropTypes.array,
	dealSources: PropTypes.array,

	// Handlers from @connect
	populateData: PropTypes.func.isRequired,
	createDeal: PropTypes.func.isRequired
});

module.exports = NewDealPage;



// WEBPACK FOOTER //
// ./modules/components/appdev/crm/NewDealPage.js